//每3位加逗號
export function numberWithCommas(x) {
	if (typeof x !== 'number' && typeof x !== 'string') {
		return
	} else {
		return String(x).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}
}
